import React from 'react';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';
import { deleteJobDescriptionFromExternalWebsite } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const DeleteJobDescriptionFromExternalWebsiteForm = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { onResponse, onError, closeDeleteJobDescriptionFromExternalWebsiteModal } = useJobDescriptionsFromExternalWebsitesActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    deleteJobDescriptionFromExternalWebsite({
      onResponse,
      onError,
      body: {
        authenticityToken,
        deleteJobDescriptionFromExternalWebsite: jobDescriptionsFromExternalWebsitesState?.deleteJobDescriptionFromExternalWebsite,
        pageNumber: jobDescriptionsFromExternalWebsitesState?.pageNumber,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to delete this job description from external website?
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeDeleteJobDescriptionFromExternalWebsiteModal()}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
          >
            Yes. Delete This Job Description from External Website.
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteJobDescriptionFromExternalWebsiteForm;